import { FC } from 'react'

import { Trash } from '@syconium/little-miss-figgy'

import { useLocalization } from '../../../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { formatPrettyCurrency } from '../../../../../lib/utils'

import {
  DeleteIconButton,
  DeleteIconColumn,
  FullPrice,
  Price,
  PriceRow,
  ValuePrice,
} from './styles'

type PriceAndDeleteButtonProps = {
  displayDiscountAsValue?: boolean
  effectivePrice: number | undefined
  fullPrice: number | undefined
  removeItem?: () => void
  title?: string
}

export const PriceAndDeleteButton: FC<PriceAndDeleteButtonProps> = ({
  displayDiscountAsValue = false,
  effectivePrice,
  fullPrice,
  removeItem,
  title = '',
}) => {
  const { locale, currency } = useLocalization()
  const {
    cart: { removeItemLabel },
    collections: {
      productGroupTile: { valueSignalLabel },
    },
  } = useTranslation()
  const isOnSale = fullPrice !== effectivePrice
  const removeItemAriaLabel = removeItemLabel.replace('{{itemTitle}}', title)

  const formattedFullPrice =
    fullPrice !== undefined
      ? formatPrettyCurrency({ value: fullPrice, unit: 'cents', locale, currency })
      : ''

  const formattedEffectivePrice =
    effectivePrice !== undefined
      ? formatPrettyCurrency({ value: effectivePrice, unit: 'cents', locale, currency })
      : ''

  return (
    <>
      <PriceRow>
        {isOnSale &&
          (displayDiscountAsValue ? (
            <ValuePrice>
              {formattedFullPrice} {valueSignalLabel}
            </ValuePrice>
          ) : (
            <FullPrice>{formattedFullPrice}</FullPrice>
          ))}
        <Price
          $displayDiscountAsValue={displayDiscountAsValue}
          $isSalePrice={isOnSale}
          data-testid='price-and-delete-button-price'
        >
          {formattedEffectivePrice}
        </Price>
      </PriceRow>

      {title && (
        <DeleteIconColumn>
          <DeleteIconButton onClick={removeItem} aria-label={removeItemAriaLabel}>
            <Trash stroke='currentColor' />
          </DeleteIconButton>
        </DeleteIconColumn>
      )}
    </>
  )
}
